import ChatPageComponent from "./ChatPage/index";

export default ChatPageComponent;
